import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const formatDateTimeLocal = (date = new Date()) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const HH = String(date.getHours()).padStart(2, "0");
    const ii = String(date.getMinutes()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd} ${HH}:${ii}`;
};
export const userOrder = create(persist(
    (set) => ({
        dataUser: {
            name: '',
            lastname: '',
            address: "No hay dirección",
            city: 0,
            city_name: "-",
            uuidShop: '',
            phone: '',
            type_document: '',
            dni_name: '',
            document: '',
            popAddress: true,
            deliveryMethod: 1,
            shopData: [],
            dateDelivery: formatDateTimeLocal(),
        },
        setDataUser: (updatedFields) => set((state) => ({
            dataUser: {
                ...state.dataUser,
                ...updatedFields
            }
        })),
        resetDataOrder: () => set(() => ({
            dataUser: {
                name: '',
                lastname: '',
                address: "No hay dirección",
                city: 0,
                city_name: "-",
                uuidShop: '',
                phone: '',
                type_document: '',
                dni_name: '',
                document: '',
                deliveryMethod: 0,
                shopData: [],
                dateDelivery: formatDateTimeLocal(),
            }
        }))
    }),
    {
        name: 'user-pleizt', // nombre para localStorage
    }
));
